//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import createUUID from '@utils/uuid';

angular.module('curalate').service('GuidService', function() {
  this.create = createUUID;
});
